'use client';

import * as React from 'react';

import { BudgetHoverOverlay } from '@/features/charts/components/chart-budget-overlay';

const WARNING_ICON =
  'M2.8418 11.3896C1.58496 11.3896 0.952148 10.6602 0.916992 9.37695L0.688477 2.79395C0.679688 2.57422 0.662109 2.33691 0.662109 2.16113C0.662109 0.790039 1.47949 -0.00976562 2.85059 -0.00976562C4.22168 -0.00976562 5.0127 0.790039 5.0127 2.16113C5.0127 2.33691 5.00391 2.57422 4.99512 2.79395L4.7666 9.37695C4.73145 10.6602 4.08984 11.3896 2.8418 11.3896ZM2.8418 16.9004C1.55859 16.9004 0.530273 15.9424 0.530273 14.7207C0.530273 13.5166 1.55859 12.5586 2.8418 12.5586C4.09863 12.5586 5.13574 13.5166 5.13574 14.7207C5.13574 15.9424 4.09863 16.9004 2.8418 16.9004Z';

export const ChartWarningIcon = ({
  x,
  y,
  maxValue,
  currValue,
  unit,
}: {
  x: number;
  y: number;
  maxValue: number;
  currValue: number;
  unit: string;
}) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const [mousePosition, setMousePosition] = React.useState({ x: 0, y: 0 });

  const handleMouseEnter = (event: React.MouseEvent) => {
    setIsHovered(true);
    setMousePosition({ x: event.clientX, y: event.clientY });
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <g
        transform={`translate(${x - 3}, ${y - 20})`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <circle cx="3" cy="8.5" r="12" fill="transparent" stroke="none" />
        <path d={WARNING_ICON} fill="url(#redSvgGradient)" />
      </g>
      <BudgetHoverOverlay
        isVisible={isHovered}
        mouseX={mousePosition.x}
        mouseY={mousePosition.y}
        maxValue={maxValue}
        currValue={currValue}
        unit={unit}
      />
    </>
  );
};

export const BasicGradientWarningIcon = ({
  maxValue,
  currValue,
  unit,
}: {
  maxValue: number;
  currValue: number;
  unit: string;
}) => {
  const [isHovered, setIsHovered] = React.useState(false);
  const [mousePosition, setMousePosition] = React.useState({ x: 0, y: 0 });

  const handleMouseEnter = (event: React.MouseEvent) => {
    setIsHovered(true);
    setMousePosition({ x: event.clientX, y: event.clientY });
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 6 17"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* Invisible larger hit area for easier hovering */}
        <circle cx="3" cy="8.5" r="12" fill="transparent" stroke="none" />
        {/* Actual warning icon */}
        <path d={WARNING_ICON} fill="url(#redSvgGradient)" />
      </svg>
      <BudgetHoverOverlay
        isVisible={isHovered}
        mouseX={mousePosition.x}
        mouseY={mousePosition.y}
        maxValue={maxValue}
        currValue={currValue}
        unit={unit}
      />
    </>
  );
};
